import { schema } from 'normalizr';
import { OrgNormalizer, LocationNormalizer } from '~/apps/shared/actions/normalize';

// Products
export const ProductNormalizer = new schema.Entity('products');

// Sales
export const SaleNormalizer = new schema.Entity('sales', {
  'location': LocationNormalizer,
});

// Additional fields
export const AdditionalFieldNormalizer = new schema.Entity('fields');
